module.exports = __webpack_public_path__ + "img/图1-7图线画法示例.45545750.jpg";